import { ThemeProvider } from "styled-components";
import { useEffect } from 'react';
import ReactGA from 'react-ga'


import type { AppProps } from "next/app";
import GlobalStyle from "../styled/GlobalStyle";
import theme from "../theme";
import { ToastContainer } from "react-toastify";
import { Provider } from "react-redux";
import { store } from "../redux/store";
import "../styles/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-day-picker/lib/style.css";
import {useRouter} from "next/router";
import TagManager from "react-gtm-module";
import {getLocation} from "../utils/getLocation";

export const initGA = () => {
    ReactGA.plugin.require("ecommerce");
}
export const logPageView = (url:any) => {
    ReactGA.pageview(url)
}
function MyApp({ Component, pageProps }: AppProps) {
    const router = useRouter();
    useEffect(() => {
        TagManager.initialize({ gtmId: 'GTM-55QK4RN' });
        getLocation()
            .then(res => {
                const data = res;
            })
            .catch(() => {

            });
        initGA();
        logPageView(window.location.href);
    }, []);
    useEffect(() => {
        const handleRouteChange = (url: any) => {
            initGA();
            logPageView(url);
        };

        router.events.on('routeChangeComplete', handleRouteChange);
        return () => {
            router.events.off('routeChangeComplete', handleRouteChange);
        };
    }, [router.events]);

    return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        <Component {...pageProps} />
        <ToastContainer />
      </ThemeProvider>
    </Provider>
  );
}

export default MyApp;
